import { Theme } from "../styles/Theme";
import { ChemistryPlayerPositions, TeamPasses } from "../types/IOption";
import { drawMiddleRect, drawPlayerHoverIcons, drawPlayerImages, drawPlayerNames, drawPlayerNamesForHulls, drawPlayerNetworks } from "./pitchWidgetUtils";
import ArrowUpWhite from "../assets/icons/ArrowUpWhite.png";
import { CurrentView, HullData } from "../types/IPitchProps";
import * as d3 from "d3";

export const drawPlayerPassingNetwork = (
  svg: d3.Selection<SVGSVGElement, unknown, any, undefined>,
  pitchGroup: d3.Selection<SVGGElement, any, null, undefined>,
  xScale: d3.ScaleLinear<number, number>,
  yScale: d3.ScaleLinear<number, number>,
  setSwapHoverPlayer: React.Dispatch<React.SetStateAction<number>>,
  setSidebarPlayerShow: (value: React.SetStateAction<boolean>) => void,
  setSwapPositionCode: (value: React.SetStateAction<string>) => void,
  setPlayerCardID: (value: React.SetStateAction<number>) => void,
  passNetworkPlayers: ChemistryPlayerPositions[],
  passNetworkPlayerPasses: TeamPasses[],
  isPerformancSwitchToggled: boolean,
  isIndividualPassing: boolean,
  setIsIndividualPassing: (value: React.SetStateAction<boolean>) => void,
  handleIndividualPassing: (playerID: number) => void,
  handleReset: () => void,
  theme: Theme
) => {
  // if (passNetworkPlayers.length < 1) {
  //   drawMiddleRect(svg, xScale, yScale, theme, ArrowUpWhite, ["Double click a", "match to select"]);
  // }
  if (passNetworkPlayers.length > 1) {
    drawPlayerNames(svg, xScale, yScale, passNetworkPlayers, theme, isPerformancSwitchToggled);
    passNetworkPlayers.map((player) => {
      if (player.playerId > 0) {
        drawPlayerImages(
          svg,
          xScale,
          yScale,
          setSwapHoverPlayer,
          player,
          [],
          theme,
          isIndividualPassing,
          undefined,
          handleReset,
          setIsIndividualPassing,
          handleIndividualPassing
        );
        if (!isIndividualPassing) {
          drawPlayerHoverIcons(
            "passingNetwork",
            svg,
            player,
            xScale,
            yScale,
            theme,
            setSwapHoverPlayer,
            setSidebarPlayerShow,
            setSwapPositionCode,
            setPlayerCardID,
          );
        }
      }
    });
  }
  if (passNetworkPlayerPasses.length > 1) {
    drawPlayerNetworks(pitchGroup, xScale, yScale, passNetworkPlayers, passNetworkPlayerPasses);
  }
};

export const drawHull = (
  svg: d3.Selection<SVGSVGElement, unknown, any, undefined>,
  pitchGroup: d3.Selection<SVGGElement, any, null, undefined>,
  xScale: d3.ScaleLinear<number, number>,
  yScale: d3.ScaleLinear<number, number>,
  hullData: HullData,
  isPerformancSwitchToggled: boolean,
  setIndividualHullPlayer : React.Dispatch<React.SetStateAction<number>>,
  individualHullPlayer : number,
  theme: Theme
) => {
  if (hullData.length > 1) {
    drawPlayerNamesForHulls(svg, xScale, yScale, hullData, theme, isPerformancSwitchToggled, setIndividualHullPlayer, individualHullPlayer);
    hullData?.map(player => {
      {individualHullPlayer > 0 && individualHullPlayer === player.playerId && player.innerHull.map(d => {
        pitchGroup
          .append("circle")
          .attr("cx", xScale(d.locationX))
          .attr("cy", yScale(d.locationY))
          .attr("r", 3)
          .style("fill", theme.playerColor);
      })}
      {individualHullPlayer > 0 && individualHullPlayer === player.playerId && player.outerHull.map(d => {
        pitchGroup
          .append("circle")
          .attr("cx", xScale(d.locationX))
          .attr("cy", yScale(d.locationY))
          .attr("r", 3)
          .style("fill", "none")
          .style("stroke-width", 1)
          .style("stroke", theme.playerColor)
      })}
      if (player.innerHull.length >=3) {
        const hullPoints = d3.polygonHull(
          player?.innerHull?.map((d) => [
            xScale(d.locationX),
            yScale(d.locationY),
          ])
        );
        const lineGenerator = d3
        .line()
        .x((d) => d[0])
        .y((d) => d[1])
        .curve(d3.curveLinearClosed);
        pitchGroup
          .append("path")
          .datum(hullPoints)
          // @ts-ignore
          .attr("d", lineGenerator)
          .style("fill", "#4AF075")
          .style("fill-opacity", individualHullPlayer > 0 ? player.playerId === individualHullPlayer ? 0.75 : 0 : 0.5)
          .style("stroke", individualHullPlayer > 0 && individualHullPlayer!==player.playerId && theme.playerDataBorder)
          .style("stroke-width", individualHullPlayer > 0 && individualHullPlayer!==player.playerId && 2)
      }
      if (player.outerHull.length >= 3) {
        if (individualHullPlayer === player.playerId) {
          const hullPoints = d3.polygonHull(
            player?.outerHull?.map((d) => [
              xScale(d.locationX),
              yScale(d.locationY),
            ])
          );
          const lineGenerator = d3
          .line()
          .x((d) => d[0])
          .y((d) => d[1])
          .curve(d3.curveLinearClosed);
          pitchGroup
            .append("path")
            .datum(hullPoints)
            // @ts-ignore
            .attr("d", lineGenerator)
            .style("fill", "#4AF075")
            .style("fill-opacity", 0.5)
        }
      }
    })
  }
}